<script setup>
import { useScrollStore } from '@/stores/scrollStore';

const storeScroll = useScrollStore();
</script>
<template>
    <button class="btn --look-sert" @click="storeScroll.scrollToId('previewSert')">посмотреть</button>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
</style>